<mat-card class="cardWithShadow theme-card">
  <mat-card-header>
    <mat-card-title class="m-b-0">Toolbar</mat-card-title>
  </mat-card-header>
  <mat-card-content class="b-t-1">
    <mat-card class="b-1 shadow-none">
      <mat-card-header>
        <mat-card-title>Basic</mat-card-title>
      </mat-card-header>
      <mat-card-content class="b-t-1">
        <mat-toolbar>
          <button
            mat-icon-button
            class="example-icon"
            aria-label="Example icon-button with menu icon"
          >
            <mat-icon>
              <i-tabler name="align-left" class="icon-20"></i-tabler>
            </mat-icon>
          </button>
          <span>My App</span>
          <span class="m-l-auto"></span>
          <button
            mat-icon-button
            class="example-icon favorite-icon"
            aria-label="Example icon-button with heart icon"
          >
            <mat-icon>
              <i-tabler name="heart-filled" class="icon-20"></i-tabler>
            </mat-icon>
          </button>
          <button
            mat-icon-button
            class="example-icon"
            aria-label="Example icon-button with share icon"
          >
            <mat-icon>
              <i-tabler name="share" class="icon-20"></i-tabler>
            </mat-icon>
          </button>
        </mat-toolbar>
      </mat-card-content>
    </mat-card>

    <mat-card class="b-1 shadow-none">
      <mat-card-header>
        <mat-card-title>Background</mat-card-title>
      </mat-card-header>
      <mat-card-content class="b-t-1">
        <mat-toolbar color="primary">
          <button
            mat-icon-button
            class="example-icon"
            aria-label="Example icon-button with menu icon"
          >
            <mat-icon>
              <i-tabler name="align-left" class="icon-20"></i-tabler>
            </mat-icon>
          </button>
          <span>My App</span>
          <span class="m-l-auto"></span>
          <button
            mat-icon-button
            class="example-icon favorite-icon"
            aria-label="Example icon-button with heart icon"
          >
            <mat-icon>
              <i-tabler name="heart-filled" class="icon-20"></i-tabler>
            </mat-icon>
          </button>
          <button
            mat-icon-button
            class="example-icon"
            aria-label="Example icon-button with share icon"
          >
            <mat-icon>
              <i-tabler name="share" class="icon-20"></i-tabler>
            </mat-icon>
          </button>
        </mat-toolbar>
      </mat-card-content>
    </mat-card>

    <mat-card class="b-1 shadow-none">
      <mat-card-header>
        <mat-card-title>Multi Row</mat-card-title>
      </mat-card-header>
      <mat-card-content class="b-t-1">
        <mat-toolbar color="primary">
          <mat-toolbar-row>
            <span>Custom Toolbar</span>
          </mat-toolbar-row>

          <mat-toolbar-row>
            <span>Second Line</span>
            <span class="m-l-auto"></span>
            <mat-icon
              class="example-icon"
              aria-hidden="false"
              aria-label="Example user verified icon"
              >verified_user</mat-icon
            >
          </mat-toolbar-row>

          <mat-toolbar-row>
            <span>Third Line</span>
            <span class="m-l-auto"></span>
            <mat-icon
              class="example-icon"
              aria-hidden="false"
              aria-label="Example heart icon"
              >favorite</mat-icon
            >
            <mat-icon
              class="example-icon"
              aria-hidden="false"
              aria-label="Example delete icon"
              >delete</mat-icon
            >
          </mat-toolbar-row>
        </mat-toolbar>
      </mat-card-content>
    </mat-card>

    <mat-card class="b-1 shadow-none">
      <mat-card-header>
        <mat-card-title>Only Brand</mat-card-title>
      </mat-card-header>
      <mat-card-content class="b-t-1">
        <mat-toolbar>
          <span>Modernize</span>
        </mat-toolbar>
      </mat-card-content>
    </mat-card>

    
  </mat-card-content>
</mat-card>
